import styled from 'styled-components';

export const UsersContainer = styled.div`
  .ant-tabs-tab {
    border-bottom: none !important;
  }

  .ant-tabs-tab-active {
    background: ${({ theme }) => theme.colors.background} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }
`;
